import { Component, computed, input } from '@angular/core';

import { CmsTarget, CmsTaxonomyGeneral } from '@fcom/core-api';

import { toLinkData } from '../../services/template/data-mappers';

interface LinkBlockContent {
  teaserTitle?: string;
  teaserText?: string;
  target?: CmsTarget;
  subjectTaxonomyTags?: Array<CmsTaxonomyGeneral | string>;
}

@Component({
  selector: 'cms-link-block',
  template: `
    @switch (linkType()) {
      @case ('cmstyle-arrow-link') {
        <fin-cta-big-link
          [target]="cmsTarget()"
          [teaserTitle]="content().teaserTitle"
          [teaserText]="content().teaserText"
          [layout]="'xsmall'"
          class="mr-xxsmall-b"
        />
      }
      @default {
        <fin-link-block
          class="mr-large-b block"
          [class.align-center]="isCentered()"
          [target]="cmsTarget()"
          [teaserTitle]="content().teaserTitle"
          [cmsTags]="cmsTags()"
        />
      }
    }
  `,
  standalone: false,
})
export class CmsLinkBlockComponent {
  content = input.required<LinkBlockContent>();

  cmsTarget = computed(() => {
    return toLinkData(this.content().target);
  });

  cmsTags = computed(() => {
    return this.content().subjectTaxonomyTags ?? [];
  });

  linkType = computed(() => {
    return this.cmsTags().find((tag) => {
      return tag.startsWith('cmstyle-');
    });
  });

  isCentered = computed(() => {
    return this.cmsTags().includes(CmsTaxonomyGeneral.CENTERED);
  });
}
